/* TPC - show WebPlanex's GST fields only on request, and only to shoppers in India. 12 Oct 2026.
 *
 * The fields themselves belong to the WebPlanex "B2B Integration" app embed. This file does NOT
 * create, rename, read or save any field, so whatever WebPlanex saves still reaches its invoice.
 * It only decides whether WebPlanex's fields are visible:
 *   - shoppers whose Shopify country is India get one link, "Need a GST invoice?", that reveals them;
 *   - everyone else never sees them;
 *   - if a GSTIN or company name is already filled in, the fields show open.
 *
 * WebPlanex injects its own markup, so its class names are not ours to rely on. The fields are found
 * by what they are: inputs inside the cart drawer whose name, id, placeholder or label mentions
 * "gst" or "company". A MutationObserver re-applies this after every drawer re-render.
 *
 * v2 (12 Oct, after the first live check showed no change): WebPlanex does not wrap both fields
 * in one box of their own, so v1 found no safe single container and, by design, did nothing. v2
 * falls back to hiding each field's own wrapper and label, so it works with either layout.
 *
 * SAFETY: anything that is part of the cart itself (line items, subtotal, order note, checkout
 * button) is never hidden. If the fields cannot be isolated from those, this does nothing and the
 * fields simply stay visible, exactly as WebPlanex shows them today.
 */
(function () {
  if (window.tpcGstToggleBound) return;
  window.tpcGstToggleBound = true;

  var OPEN_KEY = 'tpcGstOpen';
  var memChoice = null;   // the shopper's choice this page view; sessionStorage only carries it across pages
  var PROTECTED = '.checkout-buttons, .subtotal, .cart-item, textarea[name="note"], cart-note, [data-merge-list], .cart-item-upsells';

  function drawer() { return document.querySelector('cart-drawer'); }

  function isIndia(d) {
    var c = (d && d.getAttribute('data-tpc-country')) || (window.Shopify && window.Shopify.country) || '';
    return String(c).toUpperCase() === 'IN';
  }

  function textOf(input) {
    var bits = [input.name, input.id, input.placeholder, input.getAttribute('aria-label')];
    if (input.id) {
      var lab = document.querySelector('label[for="' + input.id + '"]');
      if (lab) bits.push(lab.textContent);
    }
    var prev = input.previousElementSibling;
    if (prev && prev.tagName === 'LABEL') bits.push(prev.textContent);
    return bits.join(' ').toLowerCase();
  }

  function findFields(d) {
    var inputs = d.querySelectorAll('input[type="text"], input:not([type])');
    var gst = null, company = null;
    Array.prototype.forEach.call(inputs, function (i) {
      if (i.closest('.tpc-gst-hold') === null && i.closest(PROTECTED)) return;
      var t = textOf(i);
      if (!gst && t.indexOf('gst') !== -1) gst = i;
      else if (!company && t.indexOf('company') !== -1) company = i;
    });
    return gst ? { gst: gst, company: company } : null;
  }

  function isGuard(node) {
    return node.matches && node.matches('cart-drawer, cart-form, .cart-drawer__footer, [data-merge="footer"], body');
  }

  // The pieces to show and hide. First choice: one element holding both fields and nothing of the
  // cart's own. Fallback: each field's own wrapper (the highest ancestor holding that one field and
  // nothing else that matters), plus any loose label beside it.
  function piecesFor(f, d) {
    var fields = [f.gst];
    if (f.company) fields.push(f.company);

    var node = f.gst.parentElement;
    while (node && !isGuard(node)) {
      if (fields.every(function (x) { return node.contains(x); })) {
        if (!node.querySelector(PROTECTED)) return [node];
        break;
      }
      node = node.parentElement;
    }

    var pieces = [];
    fields.forEach(function (input) {
      var unit = input;
      while (unit.parentElement && !isGuard(unit.parentElement)) {
        var up = unit.parentElement;
        if (up.querySelector(PROTECTED)) break;
        var others = Array.prototype.filter.call(up.querySelectorAll('input, select, textarea, button, a'), function (el) { return el !== input; });
        if (others.length) break;
        unit = up;
      }
      pieces.push(unit);
      // A label that sits outside the unit, directly before it. WebPlanex may use a <label> or a
      // plain text element, so accept any short, control-free element that names the field.
      var lab = unit.previousElementSibling;
      if (lab && pieces.indexOf(lab) === -1 && !lab.classList.contains('tpc-gst-link') &&
          !lab.querySelector('input, select, textarea, button, a') && !lab.matches(PROTECTED)) {
        var lt = (lab.textContent || '').toLowerCase();
        if (lt.length < 60 && (lt.indexOf('gst') !== -1 || lt.indexOf('company') !== -1)) pieces.push(lab);
      }
      if (input.id) {
        var forLab = d.querySelector('label[for="' + input.id + '"]');
        if (forLab && !unit.contains(forLab) && pieces.indexOf(forLab) === -1) pieces.push(forLab);
      }
    });

    // Never hide anything that holds a cart part.
    for (var i = 0; i < pieces.length; i++) {
      if (pieces[i].matches(PROTECTED) || pieces[i].querySelector(PROTECTED)) return null;
    }
    // Document order, so the link goes before the first piece.
    pieces.sort(function (x, y) { return x.compareDocumentPosition(y) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
    return pieces;
  }

  function apply() {
    var d = drawer();
    if (!d) return;
    var f = findFields(d);
    if (!f) return;
    var pieces = piecesFor(f, d);
    if (!pieces || !pieces.length) return;  // cannot isolate safely: leave WebPlanex as it is

    pieces.forEach(function (p) { p.classList.add('tpc-gst-hold'); });
    var first = pieces[0];

    if (!isIndia(d)) {                      // outside India: never shown
      pieces.forEach(function (p) { if (!p.hidden) p.hidden = true; });
      var stray = first.previousElementSibling;
      if (stray && stray.classList.contains('tpc-gst-link')) stray.remove();
      return;
    }

    var link = first.previousElementSibling;
    if (!link || !link.classList.contains('tpc-gst-link')) {
      link = document.createElement('button');
      link.type = 'button';
      link.className = 'tpc-gst-link';
      first.parentNode.insertBefore(link, first);
    }

    // The shopper's own choice wins; with no choice yet, filled-in details show open.
    var filled = !!((f.gst.value || '').trim() || (f.company && (f.company.value || '').trim()));
    var choice = memChoice;
    if (choice === null) {
      try { choice = sessionStorage.getItem(OPEN_KEY); } catch (e) { /* storage blocked */ }
    }
    var open = choice === '1' || (choice === null && filled);

    setState(pieces, link, open);
  }

  // Only touches the DOM when something actually changes. Writing the same text again would itself
  // be a DOM change, wake the observer, and loop forever.
  function setState(pieces, link, open) {
    pieces.forEach(function (p) { if (p.hidden !== !open) p.hidden = !open; });
    var exp = open ? 'true' : 'false';
    if (link.getAttribute('aria-expanded') !== exp) link.setAttribute('aria-expanded', exp);
    var label = open ? 'Hide GST details' : 'Need a GST invoice?';
    if (link.textContent !== label) link.textContent = label;
  }

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.tpc-gst-link') : null;
    if (!link) return;
    e.preventDefault();
    var d = drawer();
    var pieces = d ? Array.prototype.slice.call(d.querySelectorAll('.tpc-gst-hold')) : [];
    if (!pieces.length) return;
    var open = pieces[0].hidden;            // toggling
    memChoice = open ? '1' : '0';
    try { sessionStorage.setItem(OPEN_KEY, memChoice); } catch (err) { /* storage blocked */ }
    setState(pieces, link, open);
    if (open) {
      var input = d.querySelector('.tpc-gst-hold input, input.tpc-gst-hold');
      if (input) input.focus();
    }
  });

  var pending = null;
  function soon() {
    clearTimeout(pending);
    pending = setTimeout(apply, 60);
  }

  function start() {
    var d = drawer();
    if (!d) return;
    apply();
    new MutationObserver(soon).observe(d, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
